import { FC, WebCellProps } from 'web-cell';

import { SessionForm } from '../component/SessionForm';

export const SignInPage: FC<WebCellProps> = ({ className = '', style }) => (
    <main
        className={`vh-100 d-flex flex-column justify-content-center ${className}`}
        style={style}
    >
        <hgroup className="d-flex flex-column align-items-center gap-3 py-3">
            <img
                className="object-fit-contain"
                style={{ width: '72', height: '72' }}
                src="https://github.com/RMinte.png"
            />
            <h1 className="h3 m-0 font-weight-normal">ALTAI portal</h1>
            <p />
        </hgroup>

        <SessionForm
            className="m-auto"
            style={{ maxWidth: '26.25rem' }}
            onSignIn={() => (location.hash = 'admin')}
        />
        <footer className="text-center py-3">
            Proudly developed with
            <a
                className="mx-1"
                target="_blank"
                href="https://web-cell.dev/"
                rel="noreferrer"
            >
                WebCell v3
            </a>
            &amp;
            <a
                className="mx-1"
                target="_blank"
                href="https://bootstrap.web-cell.dev/"
                rel="noreferrer"
            >
                BootCell v2
            </a>
        </footer>
    </main>
);
